(function($) {
    "use strict";

    $.Tips = function(options){
        this._component_name = 'tips';
        this._tips = [];
        this._options = options || {};
        this._events = { created: "created" };

        this._on_overlay_added = this._on_overlay_added.bind(this);
        this._meta = null;
    };
    
    $.Component.create($.Tips, {
        _init_: function() {   
            this.viewers = this.parent.viewers || []; 

            if (this.parent.using_webgl) {
                var webgl = this.parent.webgl;
                webgl._on(webgl._events.overlay_added, this._on_overlay_added);
            }
            else if (this.parent._loaded_data.overlay_data){ // if overlays already loaded
                this._add_tips_immediately();
            }
            else { // if not loaded yet then wait until loaded
                this.parent._on(this.parent._events.init_overlay, this._initialize_tip.bind(this));
            } 
            
            $.Component.call(this, $.Tips);
            // this._emit(this._ev  ents.ready);
        },
        
        _get_meta: function() {
            if (!this._meta) {
                this._meta = this.parent._meta;
            }

            return this._meta;
        },

        _add_tips_immediately: function() {
            var viewer = abdo_osd.viewers[0];
            var i, overlay_prop, overlay;
            for(i = 0; i < this.parent._overlays.length; i++) {
                overlay_prop = this.parent._overlays[i];
                var overlay = viewer.getOverlayById(overlay_prop.id || overlay_prop.element.id);
                this._initialize_tip(overlay, overlay_prop);
            }
            
        },

        _on_overlay_added: function(viewer, overlay) { 
            if (this.parent._has_fields(overlay)) {
                var webgl = this.parent.webgl;
                var tip_options = Object.assign({ 
                    overlay_data: overlay,
                }, this._options); 

                if (this._get_meta()) {
                    tip_options.meta = this._meta;
                }
    
                var tip = new $.Tip(tip_options);
                tip.id = viewer.id + "-tip" + this._tips.length;
                tip.setViewer(viewer);

                tip.on(tip._events.show, this._on_tip_show.bind(this));
                tip.on(tip._events.created, this._on_tip_created.bind(this));
                overlay.tip = tip;

                webgl._on(webgl._events.click, function(object){
                    if (object.overlay == overlay) {
                        tip._parent_onclick();
                    }
                });
                this._tips.push(tip);
            } 
        },

        _initialize_tip: function(overlay, overlay_prop) { 
            if (this.parent._has_fields(overlay_prop)) {
                var tip_options = Object.assign({
                    parent_overlay: overlay, 
                    overlay_data: overlay_prop, 
                    overlay_component: this.parent
                }, this._options); 

                if (this._get_meta()) {
                    tip_options.meta = this._meta;
                }
    
                var tip = new $.Tip(tip_options); 
                tip.setViewer(overlay.viewer);
                tip.on(tip._events.show, this._on_tip_show.bind(this));
                tip.on(tip._events.created, this._on_tip_created.bind(this));
                overlay.element.tip = tip;
                this._tips.push(tip);
            } 
        },
    
        _on_tip_created: function(overlay_data, tip_element) {
            // pivot function to raise "tips_created" event on abdo_osd main object
            // so any function listening to that event can modify tip_element based on overlay_data
            this._emit(this._events.created, overlay_data, tip_element);
        },
    
        /**
         * Pan viewport when needed to show the tip
         * 
         * note: The pan tends to be incorrect when the rotation angle increases
         * @param {OpenSeadragon.Overlay} overlay 
         */
        _on_tip_show: function(overlay) { 
            var viewer = ABDOUtil.getViewer();
            
            if (viewer) {
                var vp_bounds = viewer.viewport.getBoundsNoRotate(); 
                var overlay_dom_rect = overlay.element.getBoundingClientRect(); 
                
                var overlay_rect_b = viewer.viewport.pointFromPixelNoRotate( 
                    new OpenSeadragon.Point(
                        overlay_dom_rect.x+overlay_dom_rect.width, overlay_dom_rect.y+overlay_dom_rect.height),
                        true
                );

                var offset = new OpenSeadragon.Point(
                    overlay_rect_b.x - vp_bounds.x - vp_bounds.width, 
                    overlay_rect_b.y - vp_bounds.y - vp_bounds.height);
                if (offset.x < 0) { offset.x = 0; }
                if (offset.y < 0) { offset.y = 0; }

                if (offset.x > 0 || offset.y > 0) {
                    if (overlay && typeof(overlay.location) !== "undefined") {
                        viewer.viewport.panTo(overlay.location);
                    }
                    // viewer.viewport.panBy(offset);
                } 
            }
        }
    }, $.Overlay);
})(ABDOMap);
